import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import { conversationChannelAttributes } from 'lib-shared-legacy-types';
import { useState } from 'react';
import { UnbanUserModal, } from 'components/shared/unbanUserModal/unbanUserModal';
export function UnbanUserButtonListItem(props) {
    const [isModalOpen, setModalOpen] = useState(false);
    const { user, channel, onUnban, onModalOpen } = props;
    const channelAttributes = conversationChannelAttributes.get(channel);
    function handleOnModalClose(event) {
        setModalOpen(false);
        if (!event.canceled && event.response && onUnban) {
            onUnban(event.response);
        }
    }
    function handleOnModalOpen() {
        setModalOpen(true);
        onModalOpen && onModalOpen();
    }
    return (_jsxs(_Fragment, { children: [_jsxs(ButtonList.Item, Object.assign({ icon: "undo", onClick: handleOnModalOpen }, { children: ["Unban from ", channelAttributes === null || channelAttributes === void 0 ? void 0 : channelAttributes.prettyName] })), _jsx(UnbanUserModal, { user: user, channel: channel, isOpen: isModalOpen, onClose: handleOnModalClose })] }));
}
